import Vue from 'vue'

Vue.prototype.$entitiesImagesURL = process.env.VUE_APP_ENTITIES_IMAGES_BASE_URL
Vue.prototype.$activitiesImagesURL = process.env.VUE_APP_ACTIVITIES_IMAGES_BASE_URL
Vue.prototype.$mobileUsersImagesURL = process.env.VUE_APP_MOBILE_USERS_IMAGES_BASE_URL
